import axios from "axios";
import { API_URL } from "./Api";
import {
  clearSellerSession,
  getBuyerToken,
  getSellerToken,
} from "./authStorage";

const createApiClient = (resolveToken, { onAuthFailure } = {}) => {
  const client = axios.create({
    baseURL: API_URL.api,
  });

  client.interceptors.request.use(
    (config) => {
      const token = resolveToken();

      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      } else if (config.headers?.Authorization) {
        delete config.headers.Authorization;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  if (onAuthFailure) {
    client.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error.response?.status;

        if ((status === 401 || status === 403) && resolveToken()) {
          onAuthFailure(error);
        }

        return Promise.reject(error);
      }
    );
  }

  return client;
};

const buyerApi = createApiClient(getBuyerToken);

const sellerApi = createApiClient(getSellerToken, {
  onAuthFailure: () => {
    clearSellerSession();
  },
});

const axiosInstance = buyerApi;

export { buyerApi, sellerApi };

export default axiosInstance;
